import { borderBottom } from "@material-ui/system";

/* Response Time CSS */

export default theme => ({
    rootClassName:{
        width:"100%"
    },
    rounded:{
        width:"30px",
        height:"28px",
        backgroundColor:"#FF7E00"
    },
    portletFooter:{
        borderBottom:"0px",
        backgroundColor:"red"
    },
    buttonClosed:{
        textAlign:"right",
        color:'black'
    }
});

